import * as actionTypes from '../constants/actionTypes';
export default function openInMobileReducer(state, action) {
    if (state === void 0) { state = true; }
    switch (action.type) {
        case actionTypes.HIDE_OPEN_IN_MOBILE:
            return false;
        default:
            return state;
    }
}
